import React from 'react'
import { Form } from 'react-bootstrap'
import PaginationLeftArrow from '../assets/images/paginationLeftArrow.svg'
import PaginationRightArrow from '../assets/images/paginationRight.svg'
import { FormattedMessage } from 'react-intl'

interface Props {
  page: number
  tableCount: number
  setPage: any
  backgroundColor?: string
  itemsPerPage?: number
  isPageChangeFromOtherFunction?: React.MutableRefObject<boolean>
}

const Pagination: React.FC<Props> = ({
  page,
  setPage,
  tableCount,
  backgroundColor,
  itemsPerPage,
  isPageChangeFromOtherFunction,
}) => {
  return (
    <div
      className={`mt-2 d-flex align-items-center ${
        backgroundColor || 'bg-body-color'
      }`}
    >
      <Form.Select
        value={page + 1}
        size="sm"
        className="pagination-select"
        onChange={(e) => {
          if (isPageChangeFromOtherFunction)
            isPageChangeFromOtherFunction.current = true
          setPage(+e.target.value - 1)
        }}
      >
        {Array.from(
          { length: Math.ceil(tableCount / (itemsPerPage || 10)) },
          (v, i) => +i + 1
        )?.map((pageNum) => (
          <option key={pageNum} value={pageNum}>
            {pageNum}
          </option>
        ))}
      </Form.Select>
      <span
        style={{
          fontFamily: 'Lato',
          fontWeight: '400',
          fontSize: '16px',
          lineHeight: '24px',
          color: '#525252',
          marginLeft: '10px',
        }}
        className="me-3"
      >
        <FormattedMessage id="Of" defaultMessage="of" />{' '}
        <span className="ms-1">
          {tableCount ? Math.ceil(tableCount / (itemsPerPage || 10)) : 0}
        </span>
      </span>
      <div
        className={`${page === 0 ? 'not-allowed' : 'pointer'} me-4`}
        onClick={() => {
          if (page === 0) return
          if (isPageChangeFromOtherFunction)
            isPageChangeFromOtherFunction.current = true
          setPage(page - 1)
        }}
      >
        <img
          className="mx-auto"
          src={PaginationLeftArrow}
          alt="pagination left"
        />
      </div>
      <div
        className={`${
          page + 1 === Math.ceil(tableCount / (itemsPerPage || 10))
            ? 'not-allowed'
            : 'pointer'
        }`}
        onClick={() => {
          if (page + 1 === Math.ceil(tableCount / (itemsPerPage || 10))) return
          if (isPageChangeFromOtherFunction)
            isPageChangeFromOtherFunction.current = true
          setPage(page + 1)
        }}
      >
        <img
          className="mx-auto"
          src={PaginationRightArrow}
          alt="pagination right"
        />
      </div>
    </div>
  )
}

export default Pagination
